<template>
  <th
    class="py-4 px-4 font-light group"
    :class="[
      column.sortable ? 'cursor-pointer transition-colors duration-300' : '',
      isActiveSort ? 'text-text-primary' : 'hover:text-text-secondary',
    ]"
    :title="column.title"
    @click="column.sortable ? $emit('sort', column.key) : null"
  >
    <div class="flex items-center justify-end gap-1">
      <span>{{ column.label }}</span>
      <!-- Always reserve space for sort icon -->
      <div class="w-4 h-4 flex items-center justify-center">
        <!-- Active sort icon (always visible when active) -->
        <svg
          v-if="isActiveSort"
          class="w-4 h-4 transition-colors duration-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            v-if="sortDirection === 'asc'"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 15l7-7 7 7"
          />
          <path
            v-else
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
        <!-- Hover sort icon (only visible on hover when not active) -->
        <svg
          v-else-if="column.sortable"
          class="w-4 h-4 transition-all duration-300 text-text-secondary group-hover:text-text-secondary"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
          />
        </svg>
      </div>
    </div>
  </th>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  column: {
    type: Object,
    required: true,
  },
  sortColumn: {
    type: String,
    default: null,
  },
  sortDirection: {
    type: String,
    default: 'desc',
  },
});

const emit = defineEmits(['sort']);

const isActiveSort = computed(() => props.sortColumn === props.column.key);
</script>
